module.exports = {
    aspectRatio: {
        equal: '1 / 1',
    },
    screens: {
        sss: '300px', // => @media (min-width: 300px) { ... }
        ss: '500px', // => @media (min-width: 500px) { ... }
        smb: '700px', // => @media (min-width: 700px) { ... }
    },
    width: {
        unset: 'unset',
    },
    height: {
        unset: 'unset',
    },
    colors: {
        //Hierarquia das cores
        primary: {
            100: 'rgb(60,209,151)',
            200: 'rgb(60,209,151)',
            300: 'rgb(46, 161, 116)',
            400: 'rgb(46, 161, 116)',
            500: 'rgb(33, 115, 83)',
            600: 'rgb(33, 115, 83)',
            700: 'rgb(33, 115, 83)',
            800: 'rgb(24,88,63)',
            900: 'rgb(24,88,63)',
        },
        secondary: {
            100: '#ebf8fa',
            200: '#c2e9f0',
            // 300: '#99dbe6',
            // 400: '#70cddc',
            500: '#47bed2',
            // 600: '#2da5b8',
            // 700: '#23808f',
            800: '#195b66',
            // 900: '#0f373d',
        },

        //Cores Gerais
        'sl-red': {
            default: 'rgb(158,0,0)',
            'default-antd': '#ff4d4f',
            100: '#faebeb',
            200: '#efc2c2',
            300: '#e59999',
            400: '#db7171',
            500: '#d04848',
            600: '#d04848',
            700: '#8e2424',
            800: '#661a1a',
            900: '#3d1010',
        },
        'sl-gray': {
            50: '#fafafa',
            100: '#f4f4f5',
            200: '#e4e4e7',
            300: '#d4d4d8',
            400: '#a1a1aa',
            500: '#71717a',
            600: '#52525b',
            700: '#3f3f46',
            800: '#27272a',
            900: '#18181b',
        },
        'sl-edition': {
            200: '#fed7aa',
            400: '#fb923c',
            600: '#ff5c33',
            700: '#f25d0c',
        },
        'sl-dark-mode': 'rgb(33, 33, 33)',
        'sl-grey': 'rgb(191,191,191)',
        'sl-black': 'rgb(24,23,23)',
        'sl-orange': 'rgb(226,140,5)',
        'sl-yellow': 'rgb(166,135,28)',
        'sl-brown': 'rgb(185,132,15)',
        'sl-green': 'rgb(91,135,114)',
    },
}
